module.exports = __webpack_public_path__ + "static/menu-building-5472a4c60d74b1ddc1a065c03dd0b46c.jpg";